import { ReduxThunkType } from '../../types/ReduxThunkType';
import { Actions as UserActions } from './actions';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import AccountService from '../../services/AccountService';

export const getUserInfo =
  (projectId?: number): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(UserActions.getUserInfo());
      const response = await AccountService.userInfo(projectId);
      dispatch(UserActions.getUserInfoSuccess(response.data.content));
    } catch (error) {
      dispatch(UserActions.getUserInfoError(error as RestErrorResponse));
    }
  };
